import Card from './card'
import { Search, Lightbulb, Rocket, TrendingUp, FileText } from "lucide-react";

const steps = [
  {
    number: "01",
    title: "Research & Audit",
    description: "We begin with a free consultation to understand your brand, your audience, and the competition you're up against.",
    icon: Search,
  },
  {
    number: "02",
    title: "Strategy Development",
    description: "From there, we develop a strategy that's tailored to your specific goals.",
    icon: Lightbulb,
  },
  {
    number: "03",
    title: "Execution",
    description: "From Ads, content, and campaigns; making sure everything is launched with precision.",
    icon: Rocket,
  },
  {
    number: "04",
    title: "Optimization",
    description: "But it doesn't stop at launch. We continuously monitor performance, make adjustments where needed, and keep improving the results.",
    icon: TrendingUp,
  },
  {
    number: "05",
    title: "Reporting",
    description: "Finally, we share clear, transparent reports that show what's working, what can be better, and the next steps to move your business forward.",
    icon: FileText,
  },
];

 const ProcessSection = () => {
  return (
    <section className="py-20 bg-gradient-subtle">
      <div className="mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-2 text-foreground">
            Our Process
          </h2>
          <p className="text-center text-muted-foreground mb-8 text-lg">
            A proven, systematic approach to growing your business
          </p>
          
          <div className="relative">
            {/* Desktop Arrow Line */}
            <div className="hidden lg:block absolute top-24 left-0 right-0 h-0.5 bg-gradient-to-r from-primary/20 via-primary to-primary/20"></div>
            
            <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-4">
              {steps.map((step, index) => {
                const Icon = step.icon;
                return (
                  <Card 
                    key={index} 
                    className="relative max-w-[500px] p-6 shadow-[0_8px_24px_0_rgba(59,130,246,0.15)]  hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 border-transparent hover:shadow-[0_8px_24px_0_rgba(59,130,246,0.15)]"
                  >
                    <div className="flex flex-col items-center text-center">
                      <div className="bg-blue-900 text-white w-16 h-16 rounded-full flex items-center justify-center mb-4 text-2xl font-bold shadow-lg">
                        {step.number}
                      </div>
                      <Icon className="h-8 w-8 text-orange-600 mb-4" />
                      <h3 className="font-bold text-lg mb-3 text-foreground">{step.title}</h3>
                      <p className="text-sm text-muted-foreground leading-relaxed">{step.description}</p>
                    </div>
                    
                  </Card>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;